var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0183 2.66748C7.98417 2.66748 5.51833 5.13331 5.51833 8.16748V10.8166C5.51833 11.3758 5.28 12.2283 4.99583 12.705L3.94167 14.4558C3.29083 15.5375 3.74 16.7383 4.93167 17.1416C8.8825 18.4616 13.145 18.4616 17.0958 17.1416C18.205 16.775 18.6908 15.4641 18.0858 14.4558L17.0317 12.705C16.7567 12.2283 16.5183 11.3758 16.5183 10.8166V8.16748C16.5183 5.14248 14.0433 2.66748 11.0183 2.66748Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7142 2.93332C12.43 2.85082 12.1367 2.78665 11.8342 2.74999C10.9542 2.63999 10.1108 2.70415 9.3225 2.93332C9.58834 2.25499 10.2483 1.77832 11.0183 1.77832C11.7883 1.77832 12.4483 2.25499 12.7142 2.93332Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7683 17.4717C13.7683 18.9842 12.5308 20.2217 11.0183 20.2217C10.2667 20.2217 9.57 19.91 9.075 19.415C8.58 18.92 8.26833 18.2233 8.26833 17.4717",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalsIcon);
export default __webpack_public_path__ + "static/media/terminals-icon.352c5f3c2182f10eb466e22c88019415.svg";
export { ForwardRef as ReactComponent };